/**
 * The order okjapa's questionnaires lead into each other: each result ends with the next one.
 * Shared by okjapa's result screens and Voucha's result page.
 */
export const NEXT = {
  'japa-compass': {
    slug: 'where-will-you-stand',
    name: 'Where will you stand?',
    line: 'Which class you would land in after the move, and how fast people like you climb.'
  },
  'where-will-you-stand': {
    slug: 'stay-or-go',
    name: 'Stay or go?',
    line: 'Your household\'s money in 5, 10 or 20 years if you move, and if you stay.'
  },
  'stay-or-go': {
    slug: 'make-your-money-work',
    name: 'Make your money work',
    line: 'How much you need to stop needing a salary, and when you could get there.'
  },
  'make-your-money-work': {
    slug: 'where-to-retire',
    name: 'Where to retire',
    line: 'Where your pension and savings go furthest, and what happens to each pension when you move.'
  },
  'where-to-retire': {
    slug: 'japa-compass',
    name: 'Japa Compass',
    line: 'Which of 10 countries fits you best, with the visa route for each.'
  }
};

/** The next questionnaire's address, next to this one's (same site: okjapa.com or the test site) */
export function nextUrl(currentUrl, slug) {
  return String(currentUrl || 'https://okjapa.com/').replace(/[^/]*\/?$/, '') + slug + '/';
}
flarum.reg.add('voucha-assessments', 'common/next', { NEXT: NEXT,nextUrl: nextUrl, });